import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../services/api';

const VerifyUser = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [verificationStatus, setVerificationStatus] = useState('verifying');

  useEffect(() => {
    const verifyCode = searchParams.get('code');
    
    if (!verifyCode) {
      setVerificationStatus('error');
      return;
    }

    const verifyUser = async () => {
      try {
        await api.post('/auth/verify', {
          verifyCode: verifyCode
        });
        setVerificationStatus('success');
        // Redirect to login page after successful verification
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } catch (error) {
        setVerificationStatus('error');
      }
    };

    verifyUser();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            {verificationStatus === 'verifying' && 'Verifying your account...'}
            {verificationStatus === 'success' && 'Verification Successful!'}
            {verificationStatus === 'error' && 'Verification Failed'}
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            {verificationStatus === 'verifying' && 'Please wait while we verify your account...'}
            {verificationStatus === 'success' && 'Your account has been verified successfully. Redirecting to login...'}
            {verificationStatus === 'error' && 'There was an error verifying your account. Please try again or contact support.'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerifyUser; 